export default "__VITE_ASSET__DVw4AaQA__"